export default __webpack_public_path__ + "img/b237dbed1d8f020a7c86c2cabe1050cc.svg";